import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  logos: localStorage.getItem('logos') && JSON.parse(localStorage.getItem('logos'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/logos/index.js